import { FormQuestionCodeEnum } from "../enums/form-question-code-enum";

export const STATEMENT_CODE_ALERT_MAP = new Map<FormQuestionCodeEnum, string>([
  [FormQuestionCodeEnum.StudentDocument, 'StatementStudentDocumentAlertMessage']
]);
